import { Box, Text } from '@chakra-ui/react'
import { AvailableShippingMethod } from '_app/graphql/generated/graphql'
import PriceText from '../../PriceText'
const ShippingMethodLabel = ({
                                 method,
                                 method_code,
                                 carrier_code,
                             }: any) => {
    const handleFontWeight = () => {
        if (carrier_code === 'inpostlocker' && method_code === 'standard') {
            return '600'
        }
        if (carrier_code === 'inpostcourier' && method_code === 'standardcod') {
            return '600'
        }
        return '400'
    }
    return (
        <Box fontWeight={300}>
            <Text
                sx={{
                    fontWeight: handleFontWeight()
                }}
                pr="5rem"
            >
                {method.method_title}
            </Text>
            <Box position="absolute" top={0} right={0}>
                <PriceText
                    sx={{
                        fontWeight: handleFontWeight()
                    }}
                    amount={method?.price_incl_tax}
                    floating
                    minimumFractionDigits={2}
                />
            </Box>
        </Box>
    )
}

export default ShippingMethodLabel
